(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuyu-founder"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var modal = document.querySelector('[data-founder-modal]');
    if (!modal) return;
    var openers = document.querySelectorAll('[data-founder-video-open]');
    var closers = modal.querySelectorAll('[data-founder-video-close]');
    var video = modal.querySelector('[data-founder-video-mp4]');
    var iframe = modal.querySelector('[data-founder-video-iframe]');
    var prevOverflow = '';

    function open(){
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      modal.hidden = false;
      if (iframe && iframe.dataset.src && !iframe.src) iframe.src = iframe.dataset.src;
      if (video) { try { video.currentTime = 0; video.play(); } catch(e){} }
    }
    function close(){
      modal.hidden = true;
      document.body.style.overflow = prevOverflow;
      if (video) { try { video.pause(); } catch(e){} }
      if (iframe) iframe.src = '';
    }

    openers.forEach(function(b){ b.addEventListener('click', open); });
    closers.forEach(function(b){ b.addEventListener('click', close); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) close(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuyu-range-overview"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initLoopCarousel(carousel){
      var track = carousel.querySelector('[data-track]');
      var prevBtn = carousel.querySelector('[data-prev]');
      var nextBtn = carousel.querySelector('[data-next]');
      if (!track) return;

      var originals = Array.prototype.slice.call(track.querySelectorAll('[data-original]'));
      if (originals.length < 2) return;

      originals.forEach(function(card){
        var clone = card.cloneNode(true);
        clone.removeAttribute('data-original');
        clone.setAttribute('data-clone', 'before');
        track.insertBefore(clone, track.firstChild);
      });
      originals.forEach(function(card){
        var clone = card.cloneNode(true);
        clone.removeAttribute('data-original');
        clone.setAttribute('data-clone', 'after');
        track.appendChild(clone);
      });

      var isLooping = false;
      var initialised = false;

      function getCardStep(){
        var first = track.querySelector('[data-card]');
        if (!first) return 0;
        return first.offsetWidth + 12;
      }
      function getOriginalsWidth(){
        return originals.length * getCardStep();
      }
      function setInitialPosition(){
        track.scrollLeft = getOriginalsWidth();
        initialised = true;
      }
      function handleLoop(){
        if (isLooping || !initialised) return;
        var originalsWidth = getOriginalsWidth();
        if (track.scrollLeft < originalsWidth * 0.5) {
          isLooping = true;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = track.scrollLeft + originalsWidth;
          requestAnimationFrame(function(){
            track.style.scrollBehavior = '';
            isLooping = false;
          });
        }
        else if (track.scrollLeft > originalsWidth * 2 - getCardStep() * 0.5) {
          isLooping = true;
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = track.scrollLeft - originalsWidth;
          requestAnimationFrame(function(){
            track.style.scrollBehavior = '';
            isLooping = false;
          });
        }
      }
      function scrollByCard(direction){
        track.scrollBy({ left: direction * getCardStep(), behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); scrollByCard(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); scrollByCard(1); });
      track.addEventListener('scroll', handleLoop, { passive: true });
      window.addEventListener('resize', function(){
        initialised = false;
        requestAnimationFrame(setInitialPosition);
      });

      requestAnimationFrame(function(){
        requestAnimationFrame(setInitialPosition);
      });
    }

    function initStandardCarousel(carousel){
      var track = carousel.querySelector('[data-track]');
      var prevBtn = carousel.querySelector('[data-prev]');
      var nextBtn = carousel.querySelector('[data-next]');
      if (!track) return;

      function getCardStep(){
        var first = track.querySelector('[data-card]');
        if (!first) return 0;
        return first.offsetWidth + 12;
      }
      function updateButtons(){
        if (!prevBtn || !nextBtn) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        prevBtn.disabled = track.scrollLeft <= 4;
        nextBtn.disabled = track.scrollLeft >= max;
      }
      function scrollByCard(direction){
        track.scrollBy({ left: direction * getCardStep(), behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); scrollByCard(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); scrollByCard(1); });
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    }

    document.querySelectorAll('[data-range-carousel][data-loop="true"]').forEach(initLoopCarousel);
    document.querySelectorAll('[data-range-carousel][data-loop="false"]').forEach(initStandardCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuyu-social-proof"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var scrollers = document.querySelectorAll('[data-social-scroller]');
    scrollers.forEach(function(scroller){
      var section = scroller.closest('section');
      if (!section) return;
      var prev = section.querySelector('[data-social-prev]');
      var next = section.querySelector('[data-social-next]');
      function step(dir){
        var card = scroller.querySelector('.nuyu-social__card:not([hidden])');
        if (!card) return;
        var amount = card.offsetWidth + 20;
        scroller.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function(){ step(-1); });
      if (next) next.addEventListener('click', function(){ step(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
